<template>
  <div>
    <!-- {{ offerEntry }} -->
    <b-card>
      <b-row>
        <b-col>
          <b-button-toolbar justify>
            <!--group 1 -->
            <b-button-group>
              <b-button
                v-if="!offerEntry.bookingCompleted"
                block
                variant="success"
                :disabled="!offerEntry.isActive"
                @click="createOrder"
              ><feather-icon
                 icon="CheckSquareIcon"
                 class="mr-50"
               />
                <span
                  class="align-middle"
                >Buchung für {{ offerEntry.firstName }}
                  {{ offerEntry.lastName }} erstellen</span>
              </b-button>
              <b-button
                v-else
                block
                variant="info"
                disabled
              ><feather-icon
                 icon="CheckCircleIcon"
                 class="mr-50"
               />
                <span
                  class="align-middle"
                >Angebot bereits gebucht{{ offerEntry.completedOrderId ? ` (Buchung #${offerEntry.completedOrderId})` : '' }}</span>
              </b-button>
            </b-button-group>

            <!-- group 2 -->
            <b-button-group>
              <b-button variant="danger">
                <feather-icon icon="TrashIcon" />
              </b-button>
            </b-button-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      id="modal-booking"
      size="lg"
      title="Buchen"
      ok-only
      scrollable
      ok-title="Buchung durchführen"
    >
      <b-card-text>
        <h5>Buchung</h5>
        // JSON to string
        <pre>{{ JSON.stringify(offerEntry, null, 2) }}</pre>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BCardText,
  BButton,
  BFormCheckbox,
  BButtonToolbar,
  BButtonGroup,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import helper from '@/helper/helper'
// import inquiriesHelper from '@/helper/inquiriesHelper'

export default {
  setup() {
    const { getFormattedDate } = helper()
    // const { isOfferable } = inquiriesHelper()

    return { getFormattedDate }
  },
  components: {
    BCard,
    BRow,
    BCol,
    BCardText,
    BButton,
    BFormCheckbox,
    BButtonToolbar,
    BButtonGroup,
    BModal,
    VBModal,
  },
  props: {
    offerEntry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOfferable: true,
    }
  },
  computed: {
    isBookingCompleted() {
      // Check new database field first
      if (this.offerEntry.bookingCompleted === true) {
        return true
      }

      // Fallback: Check if there's an order referencing this offer (for existing data)
      if (this.offerEntry.bookingCompleted === undefined || this.offerEntry.bookingCompleted === null) {
        const orderEntries = this.$store.getters.orderEntries || []
        return orderEntries.some(order => order.offer_id === this.offerEntry.id
          || order.offer === this.offerEntry.id
          || (order.offer && order.offer.id === this.offerEntry.id))
      }

      return false
    },
  },
  methods: {
    createOrder() {
      // Prevent booking if already completed
      if (this.isBookingCompleted) {
        this.$toast.warning('Dieses Angebot wurde bereits gebucht')
        return
      }

      console.log(
        `createOrder() - offerEntry.id: ${this.offerEntry.id}`,
        this.offerEntry
      )

      // this.$bvModal.show('modal-booking')
      const activeStorage = this.offerEntry.storages.filter(
        storage => storage.storageReservation === true
      )

      console.log('🔍 Storage data for booking:', {
        totalStorages: this.offerEntry.storages.length,
        storagesWithReservation: activeStorage.length,
        allStorages: this.offerEntry.storages.map(s => ({
          id: s.id,
          ident: s.storageIdent,
          reservation: s.storageReservation
        }))
      })

      // If no storages have reservations, use all storages
      const storagesForBooking = activeStorage.length > 0 ? activeStorage : this.offerEntry.storages

      this.$router.push({
        name: 'Direktbuchung',
        params: {
          booking: this.offerEntry,
          storages: storagesForBooking,
          parentRoute: 'offer',
        },
      })
    },
  },
}
</script>
<style lang="scss">
hr.style1 {
  border-top: 1px solid #8c8b8b;
}
hr.style5 {
  background-color: #fff;
  border-top: 2px dashed #8c8b8b;
}
</style>
